import { LibService } from './libService';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocietyService {

  baseApi = environment.rootApiFoundation + 'societies';

  constructor(
    public libService: LibService,
  ) { }

  getAllSocieties(): Observable<any> {
    return this.libService.getData<any>(this.baseApi, '');
  }

  getSociety(id: string) {
    return this.libService.getData<any>(this.baseApi + '/', id.toString());
  }

}
